import { Alert, Box, Stack, Typography } from "@mui/material";

import { Issue } from "../features/appState/issuesSlice";
import { createStyleSheet } from "../utils/styles";
import { useTranslation } from "react-i18next";

const IssuesList = (props: {
  issues: Issue[];
  onRetryFn: (issueId: string) => void;
  onCloseFn: (issueId: string) => void;
}) => {
  const { t } = useTranslation();
  return props.issues.length > 0 ? (
    <Stack sx={styles.container} spacing={1}>
      {props.issues.map((issue) => (
        <Alert
          key={issue.id}
          severity={issue.type}
          color="warning"
          onClose={() => props.onCloseFn(issue.id)}
        >
          <Box key={issue.id} sx={styles.issueRow}>
            <Typography variant="body2" sx={styles.descriptionText}>
              {issue.description}
              {issue.retryData ? (
                <Typography
                  variant="body2"
                  component="span"
                  onClick={() => props.onRetryFn(issue.id)}
                  sx={styles.retryText}
                >
                  {" "}
                  <b>{t("common:retrySendAction")}</b>
                </Typography>
              ) : null}
            </Typography>
          </Box>
        </Alert>
      ))}
    </Stack>
  ) : null;
};

const styles = createStyleSheet({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  issueRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  descriptionText: {
    flex: 1,
    marginLeft: 1,
  },
  retryText: {
    cursor: "pointer",
    display: "inline",
  },
});

export default IssuesList;
